// src/modules/restaurant/pages/respayment/components/PaymentCompletedCard.tsx
import React from "react";

const PaymentCompletedCard: React.FC = () => (
  <div className="mt-auto">
    <div className="bg-gradient-to-r from-green-50 to-emerald-100 border-2 border-green-200 rounded-2xl p-2 text-center shadow-lg">
      {/* <div className="flex items-center justify-center gap-3 text-green-700 mb-3"> */}
        {/* <div className="w-4 h-4 bg-green-500 rounded-full animate-pulse"></div> */}
        <span className="font-bold text-lg">Payment Completed</span>
      {/* </div> */}
      <p className="text-green-600 text-sm">Thank you for your business! 🎉</p>
    </div>
  </div>
);

export default PaymentCompletedCard;
